'use client';

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({ component: Home });
export default function Home() {
  return <div className=''>Version: {import.meta.env.VITE_GIT_REF_NAME ?? 'dev'}</div>;
}
